import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
	root: {
		color: theme.palette.error.main,
		padding: "10px 0",
		fontSize: "12px",
		fontFamily: theme.typography.fontFamily,
		textAlign: "right",
	}
}));
